interface StepperResolverOptions<T> {
  stepper: T;
}

export const stepperResolverFactory = <T>(options: StepperResolverOptions<T>): StepperResolverOptions<T> => {
  return options;
};
